import DeleteIcon from "@material-ui/icons/Delete";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { OrangeButton } from "../general/OrangeButton";
import {
  LOCATION,
  MASTERGROUP,
  OPERATION,
} from "../store/businesslogic/hardwiredlogic";
import {
  currentNodeChangedOnDirectGroupClick,
  currentNodeChangedOnDirectLocationClick,
  getAddButtonText,
  getAddressPartForLocation,
  getAnswersFromDoc,
  getCurrentNode,
  getFormsOrder,
  getFormState,
  getLocationsOrder,
  getMasterGroupText,
  getNode,
  updateProspectForms,
  getSecondLevelText,
  removeLocationToFormThunk,
  removeBuildingToFormThunk,
  updateAddressParts,
  prefillAddressParts,
  getBuildings,
  currentNodeChangedOnDirectBuildingClick,
  getGroupsOrderFromLocationState,
  getShowFirstAutoAddedBuildingState,
  getIsGroupQuestionsAnyPriority,
  addGroupIdToNonPriorityGroups,
  getNonPriorityGroups,
  addBuildingToLocationState,
  setShowFirstAutoAddedBuilding
} from "../store/qf";
import { Modal, Button } from "react-bootstrap";
import { getBrokerInformation } from "../store/broker";
import * as theme from "../theme";
import GroupNavs from "./GroupNavs";
import { giveLocationAddresses } from "common-func-quotey";
import _ from "lodash";
import { FaPray } from "react-icons/fa";
import translations from "../utils/translations";

const FormSubGroupsNav = ({ formid, groupsorder, formtype }) => {
  let { information } = useSelector(getBrokerInformation);
  const languagepreference = information.languagepreference;
  const contentAsPerFormType = ({ formtype }) => {
    if (formtype === LOCATION)
      return <LocationNumberedTabs formid={formid}></LocationNumberedTabs>;
    if (formtype === MASTERGROUP || formtype === OPERATION)
      return groupsorder.map((groupid) => (
        <EachMasterGroupTabs
          key={`groupid_${groupid}`}
          groupid={groupid}
          formid={formid}
        ></EachMasterGroupTabs>
      ));
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        backgroundColor: theme.COLORS.qf_nav_plus_button_color,
        paddingLeft: "9%",
        paddingRight: "10%",
        letterSpacing: 1.3,
        paddingTop: "2vh",
        paddingBottom: "2vh",
        fontSize: "1.7vmin",
      }}
    >
      {contentAsPerFormType({ formtype })}
    </div>
  );
};

const EachMasterGroupTabs = ({ groupid, formid }) => {
  const currentnode = useSelector(getCurrentNode);
  const text = useSelector(getMasterGroupText(formid, groupid));
  const isGroupAnyPriority = useSelector(getIsGroupQuestionsAnyPriority({formid, groupid}))
  const dispatch = useDispatch();
  const nonPriorityGroups = useSelector(getNonPriorityGroups)
  const [display, setDisplay] = useState("flex");
  let { information } = useSelector(getBrokerInformation);
  const languagepreference = information.languagepreference;
  
  useEffect(() => {
    isGroupAnyPriority ? setDisplay("flex") : setDisplay("none")
  }, [isGroupAnyPriority, dispatch]);

  const handleGroupTabsClick = () => {
    dispatch(currentNodeChangedOnDirectGroupClick(groupid));
  };

  const ifSelectedGroup = () => {
    if (currentnode.formid === formid && currentnode.groupid === groupid)
      return true;
    return false;
  };

  return (
    <GroupNavs
      key={`groupid_${groupid}`}
      isopen={ifSelectedGroup()}
      text={text}
      display={display}
      htmlid={`groupid_${groupid}`}
      handleGroupTabsClick={handleGroupTabsClick}
    ></GroupNavs>
  );
};

const LocationNumberedTabs = ({ formid }) => {
  const locationsorder = useSelector(getLocationsOrder(formid));
  let isAtleastTwoLocationAvailable = locationsorder.length > 1 ? true : false;
  const currentnode = useSelector(getCurrentNode);
  let { information } = useSelector(getBrokerInformation);
  const languagepreference = information.languagepreference;

  return locationsorder.map((locationid, index) => {
    return (
      <EachLocationNumberedTabs
        key={`location_${locationid}`}
        locationid={locationid}
        index={index}
        formid={formid}
        showDeleteOption={isAtleastTwoLocationAvailable}
      ></EachLocationNumberedTabs>
    );
  });
};

const useDidMountEffect = (func, deps) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) {
      func();
    } else {
      didMount.current = true;
    }
  }, deps);
};

const DeleteIconWithLocation = ({
  index,
  showDeleteOption,
  locationid,
  formid,
}) => {
  const [hover, setHover] = useState(false);
  const [deleteHover, setDeleteHover] = useState(false);
  const addressPart = useSelector(
    getAddressPartForLocation({ formid, locationid })
  );
  const secondLevelText = useSelector(getSecondLevelText({ formid }));
  const delay = (ms) => new Promise((res) => setTimeout(res, ms));
  const dispatch = useDispatch();

  const formState = useSelector(getFormState);
  const allNodeIdArraysThatCanChangeAddressParts = () => {};
  const lastBuildingIndex = formState[formid]?.locationstate[locationid]?.buildings?.length;
  var lastBuildingAnswered = null
  if(lastBuildingIndex)
   lastBuildingAnswered = formState[formid]?.locationstate[locationid]?.buildings[lastBuildingIndex-1]?.groupsorder?.length > 1;

  let { information } = useSelector(getBrokerInformation);
  const languagepreference = information.languagepreference;

  const qLocation500100 = useSelector(
    getNode({ formid, locationid, questionid: "500100" })
  );
  const qLocation500101 = useSelector(
    getNode({ formid, locationid, questionid: "500101" })
  );
  const qLocation500110 = useSelector(
    getNode({ formid, locationid, questionid: "500110" })
  );

  const getArrayWithoutNulls = ({ inputArray }) => {
    let returnArray = [];

    inputArray.forEach((e) => {
      if (e) returnArray.push(e);
    });

    return returnArray;
  };

  useEffect(() => {
    if (addressPart === undefined && index === 0) {
      // call the api and dispatch-> updateAddressParts
      dispatch(updateAddressParts({ formid }));
    }
  }, []);

  useEffect(() => {
    // call the api and dispatch-> updateAddressParts
    dispatch(updateAddressParts({ formid }));
  }, [
    qLocation500100?.answer,
    qLocation500101?.answer,
    qLocation500110?.answer,
  ]);

  useEffect(() => {
    // call the api and dispatch-> updateAddressParts
    dispatch(prefillAddressParts({ formid }));
    dispatch(updateProspectForms({ updateFormsOrder: true }));
  }, [qLocation500100?.answer]);

  const decideSecondLevelText = ({ secondLevelText }) => {
    if (secondLevelText) {
      return secondLevelText;
    }

    return translations[languagepreference].locationFallback;
  };

  return (
    <div
      onMouseOver={() => {
        setHover(true);
      }}
      onMouseOut={async () => {
        await delay(1000);
        setHover(false);
      }}
      style={{display:'flex', flexDirection:'row', alignItems:"center", width: "100%", justifyContent:"space-between", fontSize:"medium"}}
    >
      {`${decideSecondLevelText({ secondLevelText })}  #${index + 1}  ${
        addressPart ? " - " + addressPart : ""
      }`}
      {showDeleteOption && (hover || deleteHover) ? (
        <DeleteIcon
          onClick={(e) => {
            e.stopPropagation();
            console.table({ locationid });
            dispatch(removeLocationToFormThunk({ formid, locationid }));
          }}
          onMouseOver={() => {
            setDeleteHover(true);
          }}
          onMouseOut={async () => {
            // await delay(500);
            setDeleteHover(false);
          }}
        >
          
          {translations[languagepreference].deleteButton}
        </DeleteIcon>
      ) : null}
      { lastBuildingAnswered && (
        <OrangeButton
          text={translations[languagepreference].addPropertyButton}
          fontSize={"x-small"}
          onClick={(e) => {
            let newBuildingIndex = formState[formid].locationstate[locationid].buildings.length 
            dispatch(setShowFirstAutoAddedBuilding(true));
            dispatch(
              addBuildingToLocationState({
                formid,
                locationid,
                buildingIndex: newBuildingIndex,
                focusDisabled: null
              })
            );
            setTimeout(() => {
              const button = document.getElementById(`location_${locationid}_building_${newBuildingIndex}_59000a`);
              if(button){
                button.click();
              }
            }, 500);
          }}
        />
      )}
    </div>
  );
};

const DeleteIconWithBuilding = ({
  index,
  showDeleteOption,
  locationid,
  formid,
  buildingid,
}) => {
  const [hover, setHover] = useState(false);
  const [deleteHover, setDeleteHover] = useState(false);
  const dispatch = useDispatch();
  const delay = (ms) => new Promise((res) => setTimeout(res, ms));
  const [buildingTitle, setBuildingTitle] = useState("");
  const formState = useSelector(getFormState);
  const [show, setShow] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  let { information } = useSelector(getBrokerInformation);
  const languagepreference = information.languagepreference;

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const descriptionKeyId = `location_${locationid}_building_${buildingid}_59000a`;
  useEffect(() => {
    const formid = formState.currentnode.formid;

    // Construct the key for localStorage based on locationId and buildingId
    const descriptionKey = `location_${locationid}_building_${buildingid}_59000a`;
    const buildingTitle =
      formState[formid]["nodestate"][descriptionKey]?.answer;
    // If the value exists in localStorage, use it, otherwise, use the default value
    if (buildingTitle) {
      setBuildingTitle(buildingTitle);
    } else {
      setBuildingTitle(translations[languagepreference].defaultBuildingTitlePrefix + (parseInt(buildingid) + 1));
    }
  }, [formState, locationid, buildingid,languagepreference]);

  return (
    <div
      onMouseOver={() => {
        setHover(true);
      }}
      onMouseOut={async () => {
        await delay(1000);
        setHover(false);
      }}
      id={descriptionKeyId}
    >
      {buildingTitle}
      {showDeleteOption && buildingid > 0 && (hover || deleteHover) ? (
        <DeleteIcon
          onClick={(e) => {
            e.stopPropagation();
            console.table({ locationid });
            handleShow();
            // dispatch(
            //   removeBuildingToFormThunk({ formid, locationid, buildingid })
            // );
          }}
          onMouseOver={() => {
            setDeleteHover(true);
          }}
          onMouseOut={async () => {
            // await delay(500);
            setDeleteHover(false);
          }}
        >
         { translations[languagepreference].deleteButton}
          
        </DeleteIcon>
      ) : null}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
          {translations[languagepreference].removePropertyModalTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {translations[languagepreference].removePropertyModalBody}
         </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
          {translations[languagepreference].cancelButton}
            
          </Button>
          <Button
            variant="danger"
            disabled={isDeleting}
            onClick={() => {
              setIsDeleting(true);
              handleClose();
              setShow(false);
              dispatch(
                removeBuildingToFormThunk({ formid, locationid, buildingid })
              );

              setIsDeleting(false); // Reset the state once the deletion is complete
            }}
          >
              {translations[languagepreference].deleteButton}
            
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

const EachLocationNumberedTabs = ({
  locationid,
  index,
  formid,
  showDeleteOption,
}) => {
  const currentnode = useSelector(getCurrentNode);
  const locationOrder = useSelector(
    getGroupsOrderFromLocationState({ formid, locationid })
  );
  const buildings = useSelector(getBuildings({ formid, locationid }));
  const showAutoAddedBuilding = useSelector(getShowFirstAutoAddedBuildingState);

  const isActiveLocation =
    currentnode.formid === formid && currentnode.locationid === locationid;

  //   const isBuildingLocationActive = currentnode.formid === formid && currentnode.locationid === locationid  && currentnode.locationid === locationid;
  const [isBuildingLocationActive, setIsBuildingLocationActive] = useState();
  const [currentNodeBuilding, setCurrentNodeBuilding] = useState(
    currentnode.buildingid
  );
  const [currentLocationId, setCurrentLocationId] = useState(
    currentnode.locationid
  );
  const [buildingList, setBuildingList] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    setCurrentNodeBuilding(currentnode.buildingid);
    setCurrentLocationId(parseInt(currentnode.locationid));
  }, [currentnode]);

  const handleLocationTabsClick = () => {
    dispatch(currentNodeChangedOnDirectLocationClick({ locationid }));
  };

  const handleBuildingTabClick = (buildingid) => {
    dispatch(
      currentNodeChangedOnDirectBuildingClick({ locationid, buildingid })
    );
  };

  useEffect(() => {
    if (
      buildings &&
      buildings[0].groupsorder.length > 0 &&
      _.includes(locationOrder, "e_100_50")
    ) {
      setBuildingList(buildings);
    } else {
      setBuildingList([]);
    }
  }, [buildings, locationOrder]);

  return (
    <>
      <GroupNavs
        text={
          <DeleteIconWithLocation
            index={index}
            showDeleteOption={showDeleteOption}
            locationid={locationid}
            formid={formid}
          ></DeleteIconWithLocation>
        }
        isopen={isActiveLocation}
        handleGroupTabsClick={handleLocationTabsClick}
        htmlid={`location_${locationid}`}
      ></GroupNavs>

      {buildingList &&
        buildingList.map((building, index) => {
          return (
            <GroupNavs
              text={
                <DeleteIconWithBuilding
                  index={index}
                  showDeleteOption={true}
                  locationid={locationid}
                  formid={formid}
                  buildingid={index}
                ></DeleteIconWithBuilding>
              }
              // text={"Bulding #" + (parseInt(index) + 1)}
              isopen={
                currentLocationId === locationid &&
                currentNodeBuilding === index
              }
              handleGroupBuildingTabClick={() => {
                handleBuildingTabClick(index);
              }}
              isSubGroup={true}
            ></GroupNavs>
          );
        })}
    </>
  );
};

export default FormSubGroupsNav;
